import api from './axiosInstance';

export const getCropDataListApi  = (params)    => api.get('/crops-data', { params });
export const getCropDataByIdApi  = (id)        => api.get(`/crops-data/${id}`);
export const createCropDataApi   = (data)      => api.post('/crops-data', data);
export const updateCropDataApi   = (id, data)  => api.put(`/crops-data/${id}`, data);
export const deleteCropDataApi   = (id)        => api.delete(`/crops-data/${id}`);
export const getCropAdvisoryApi  = (id, params) => api.get(`/crop-advisory/${id}`, { params });
export const aiGetCropDataApi    = (crop_name)  => api.post('/ai/crop-request', { crop_name });
